<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated">
      <div class="body_con" v-show="pageData">
        <el-carousel
          class="el-carousel"
          :height="(screenWidth / 1920) * 600 + 'px'"
          trigger="click"
          :interval="5000"
          v-if="pageData.carousel"
        >
          <el-carousel-item v-for="item in pageData.carousel" :key="item.src">
            <img
              :src="img_head_url + item.src"
              style="width: 100%; height: 100%; min-width: 1200px"
            />
          </el-carousel-item>
        </el-carousel>
        <div class="featured_pages">
          <el-row :gutter="0">
            <el-col
              :span="8"
              v-for="(item, index) in pageData.tese"
              :key="'tese' + index"
            >
              <el-image
                class="featured_icon"
                :src="
                  img_head_url +item.src
                "
                alt=""
                :lazy="true"
              ></el-image>
              <p class="featured_p">{{item.title}}</p>
              <span style="padding:0 50px;display: block;line-height: 25px;">{{item.text}}</span
              >
            </el-col>
          </el-row>
          <!-- <ul class="flex-display flex-wrap">
            <li>
              <div class="featuredbox">
                <el-image
                  :src="
                    img_head_url +
                    '/storage/topic/20240106/218ffc89ca907bb9cceaea27d23ef2a6.png'
                  "
                  alt=""
                  :lazy="true"
                ></el-image>
                <p>Vision</p>
                <span
                  >Asunt in anim uis aute irure dolor in est idreprehenderit in
                  voluptate velit esse cillumdolore eu fugiat nulla pariatur
                  Excepteur.</span
                >
              </div>
            </li>
            <li>
              <div class="featuredbox">
                <el-image
                  :src="
                    img_head_url +
                    '/storage/topic/20240106/218ffc89ca907bb9cceaea27d23ef2a6.png'
                  "
                  alt=""
                  :lazy="true"
                ></el-image>
                <p>Popular products</p>
                <span
                  >Asunt in anim uis aute irure dolor in est idreprehenderit in
                  voluptate velit esse cillumdolore eu fugiat nulla pariatur
                  Excepteur.</span
                >
              </div>
            </li>
            <li>
              <div class="featuredbox">
                <el-image
                  :src="
                    img_head_url +
                    '/storage/topic/20240106/218ffc89ca907bb9cceaea27d23ef2a6.png'
                  "
                  alt=""
                  :lazy="true"
                ></el-image>
                <p>R&D department</p>
                <span
                  >Asunt in anim uis aute irure dolor in est idreprehenderit in
                  voluptate velit esse cillumdolore eu fugiat nulla pariatur
                  Excepteur.</span
                >
              </div>
            </li>
          </ul> -->
        </div>
        <div class="featured_pages" v-if="pageData.tese">
          <div class="featured_item"  v-for="(item, index) in pageData.tese"
                :key="'teses' + index" :style="`display:inline-block;width:${imgWidth}`" @click="gotoDetail(item.new_id,item.service_type)">
              <!-- <a :href="'#/NewDetail?id=' + item.new_id"
                :style="`text-decoration: none;width:${imgWidth}`"
              > -->
                <el-card >
                  <div class="featured_pic">
                    <!-- <img
                      class="featured_bg"
                      src="../assets/img/news_bg.png"
                      style="height: 400px"
                      alt=""
                    /> -->
                    <el-image
                      class="img"
                      :style="`width:${imgWidth}`"
                      :src="img_head_url + item.news_src"
                      :alt="item.title"
                      :lazy="true"
                    ></el-image>
                  </div>
                  <div class="featured_box">
                    <p class="featured_title">
                      {{ item.news_title }}
                    </p>
                    <span  class="featured_introduce">{{ item.news_text }}</span>
                  </div>
                </el-card>
              <!-- </a> -->
          </div>
        </div>
        <div class="un_con">
          <el-row :gutter="100">
            <el-col :span="12">
              <div class="un_title">{{ $t("home.WhyChooseUs") }}</div>
              <div class="un_box">
                <div class="us_content" v-html="pageData.jianjie.text"></div>
                <!-- <div class="us_value"><i class="el-icon-check"></i>Duis mi eros, interdum eu ultricies vel, interdum viverra mi.</div>
                <div class="us_value"><i class="el-icon-check"></i>Interdum et malesuada fames ac ante ipsum primis in.</div>
                <div class="us_value"><i class="el-icon-check"></i>Donec pharetra hendrerit nisl, Nulla semper magna ut pulvinar.</div> -->
                <router-link to="/Products">
                <div class="more">
                   <i class="el-icon-s-promotion"></i>{{ $t("home.PurchaseNow") }}
                </div>
                </router-link>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="un_title">{{ $t("home.LatestNews") }}</div>
              <div class="un_box">
                <div class="new_item flex" v-for="(item, index) in pageData.news" :key="'news' + index" @click="gotoNewDetail(item.id)">
                  <div class="new_time">
                    <div class="date">{{item.show_day}}</div>
                    <div class="month">{{item.show_month}}</div>
                  </div>
                  <div class="new_box">
                    <div class="new_title">{{item.title}}</div>
                    <div class="new_content">{{item.sub_title}}<span>{{ $t("home.ReadMore") }}<i class="el-icon-right"></i></span></div>
                  </div>
                  <div style="clear: both;"></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="clear: both;"></div>
        <div class="client_con">
           <div class="client_title">{{ $t("home.SomeofOurClients") }}</div>
           <div class="client_box flex">
            <el-image
                class="client_icon" v-for="(item, index) in pageData.kehu" :key="'kehu' + index"
                :src="
                  img_head_url +item.src
                "
                alt=""
                :lazy="true"
              ></el-image>
           </div>
        </div>
        <!-- <div class="con_title">{{ $t("top.About") }}</div>
        <div class="about_con" v-if="pageData.jianjie">
          <img :src="img_head_url + pageData.jianjie.src" alt="" />
          <router-link to="/About" class="more">{{
            $t("common.LearnMore")
          }}</router-link>
        </div> -->
        <!-- <div class="con_title">{{ $t("top.Products") }}</div>
        <div class="product_con" v-if="pageData.pro">
          <ul
            class="flex-display flex-wrap"
            :style="`background-image: url(${img_head_url}${pageData.beijing.src});`"
          >
            <li v-for="(item, index) in pageData.pro" :key="'pro' + index">
              <router-link :to="'/ProductDetail?id=' + item.id" class="more">
                <div class="imgbox">
                  <el-image
                    :src="img_head_url + item.src"
                    alt=""
                    :lazy="true"
                  ></el-image>
                </div>
                <p>{{ item.title }}</p>
                <span>{{ $t("common.LearnMore") }}</span>
              </router-link>
            </li>
          </ul>
        </div> -->
        <!-- <div class="con_title">{{ $t("top.News") }}</div>
        <div class="news_con" v-if="pageData.news">
          <el-row :gutter="12">
            <el-col
              :span="6"
              v-for="(item, index) in pageData.news"
              :key="'news' + index"
            >
              <a
                :href="'#/NewDetail?id=' + item.id"
                style="text-decoration: none"
              >
                <el-card>
                  <div class="news_pic">
                    <img class="bg" src="../assets/img/news_bg.png" alt="" />
                    <el-image
                      class="img"
                      :src="img_head_url + item.src"
                      :alt="item.title"
                      :lazy="true"
                    ></el-image>
                  </div>
                  <div class="news_box">
                    <p class="news_title">
                      {{ item.title }}
                    </p>

                    <div class="news_icon flex-display">
                      <p class="news_time">{{ item.create_time }}</p>

                      <div class="news_detail flex-display">
                        <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </el-card>
              </a>
            </el-col>
          </el-row>
        </div> -->
      </div>
    </div>
    <BackToTop></BackToTop>
  </div>
</template>
<script>
import BackToTop from '../components/common/BackToTop'
export default {
  computed: {},
  components: {
    BackToTop
  },
  data () {
    return {
      pageData: '',
      img_head_url: '',
      lang: localStorage.lang || 'cn',
      screenheight: '',
      screenWidth: '',
      imgWidth: ''
    }
  },
  created () {
    console.log(this)
    // window.onresize = () => {
    //   return () => {
    //     this.screenheight =
    //       (document.body.clientWidth / 1920) * 600 + 'px'
    //   }
    // }
    this.getPageData()
  },
  mounted () {
    this.screenWidth = document.body.clientWidth // 监听页面缩放
    this.screenHeight = document.body.clientHeight
    this.imgWidth = document.body.clientWidth > 1600 ? parseInt((document.body.clientWidth * 0.75 - 80) / 3) + 'px' : 380 + 'px'
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
        this.imgWidth = document.body.clientWidth > 1600 ? parseInt((document.body.clientWidth * 0.75 - 80) / 3) + 'px' : 380 + 'px'
      })()
    }
  },
  methods: {
    getPageData () {
      var that = this
      var json = {
        lang: that.lang
      }
      var url = '/api/get_home_page_data'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.pageData = res.data
          that.img_head_url = res.img_head_url
        }
      })
    },
    about () {
      this.$router.push('/About')
    },
    gotoDetail (id, type) {
      if (type === 0) {
        this.$router.push({ path: '/NewDetail', query: { id: id } })
      } else if (type === 1) {
        this.$router.push({ path: '/ServiceDetail', query: { id: id } })
      }
    },
    gotoNewDetail (id) {
      console.log(id)
      this.$router.push({ path: '/NewDetail', query: { id: id } })
    }
  },
  watch: {
    screenWidth () {
      // this.screenHeight = (this.screenWidth / 1920) * 600 + 'px'
      // console.log(this.screenWidth) // 浏览器窗口变化时，打印宽度。
    }
  }
}
</script>

<style scoped>
.carousel_con {
  display: block;
  width: 100%;
  min-width: 1200px;
  /* margin-bottom: 20px; */
  position: relative;
}
/* about */
.about_con {
  display: table;
  table-layout: fixed;
  width: 100%;
  min-width: 1200px;
  height: auto;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  /* background-image: url(../assets/img/about_bg.jpg); */
  background-size: 100% 100%;
}
.about_con img {
  width: 100%;
  height: 100%;
  display: block;
}
.about_con .more {
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 1);
  display: inline-block;
  padding: 13px 56px;
  letter-spacing: 2px;
  border-radius: 50px;
  text-decoration: none;
  position: absolute;
  top: 66%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.about_con .more:hover {
  background: #3c427c;
  border: 1px solid #3c427c;
}

/* product */
.product_con {
  padding: 0;
  width: 100%;
  min-width: 1200px;
}

.product_con .title {
  padding: 0 6%;
  margin-bottom: 40px;
}

.product_con .title .text {
  -webkit-flex: 1;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  -moz-flex: 1;
  flex: 1;
  overflow: hidden;
}

.product_con .title h2 {
  color: #01967a;
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 10px;
}

.product_con .title h4 {
  color: #666;
  font-size: 18px;
}

.product_con .title .icon {
  text-align: center;
  margin-left: 60px;
}

.product_con .title i {
  font-size: 32px;
  color: #999;
}

.product_con .title p {
  font-size: 16px;
  color: #999;
  margin-top: 15px;
}

.product_con ul {
  /* background-image: url(../assets/img/product_bg.jpg); */
  background-position: center;
  background-size: cover;
  margin-block: 0;
  padding-inline: unset;
}

.product_con li {
  -webkit-flex: 1;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  -moz-flex: 1;
  flex: 1;
  overflow: hidden;
  text-align: center;
  transition: all 0.3s;
  position: relative;
}

.product_con li:hover {
  background-color: rgba(60, 66, 124, 0.7);
}

.product_con li::before {
  display: block;
  content: "";
  position: absolute;
  z-index: 4;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  border: 1px solid #fff;
  opacity: 0;
  transition: all 0.3s;
}

.product_con li:hover::before {
  opacity: 1;
}

.product_con li + li {
  border-left: 1px solid #777;
}

.product_con li a {
  display: block;
  padding: 75px 40px;
  position: relative;
  z-index: 5;
}

.product_con li .imgbox {
  /* height: 300px; */
  margin-bottom: 40px;
}

.product_con li img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.product_con li .el-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product_con li p {
  font-size: 15px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
}

.product_con li span {
  font-size: 12px;
  color: #999;
  display: inline-block;
  padding: 5px 20px;
  border: 1px solid #999;
  border-radius: 16px;
}

.product_con li:hover span {
  border-color: #fff;
  color: #3c427c;
  background-color: #fff;
}
/* news_con */
.news_con {
  display: block;
  width: 75%;
  min-width: 1200px;
  margin: 0px auto;
  position: relative;
}
::v-deep .news_con .el-card__body {
  padding: 0;
}
.news_con .news_pic {
  overflow: hidden;
  font-size: 0;
  position: relative;
}
.news_con .news_pic .bg {
  width: 100%;
  transition: all 0.3s;
}
.news_con .news_pic .img {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  max-width: 100%;
}
.news_con .el-card:hover .news_pic .img {
  transform: scale(1.1);
}
.news_con .news_box {
  position: relative;
  padding: 30px;
  background-color: #ffffff;
}
.news_con .el-card:hover .news_box {
  background-color: rgba(60, 66, 124, 0.7);
  color: #fff;
}
.news_con .news_box .news_title {
  color: #333;
  margin: 0 0 18px 0;
  height: 60px;
  line-height: 30px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 22px;
}
.news_con .el-card:hover .news_title {
  color: #fff;
}
.news_con .news_box .news_icon {
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  line-height: 30px;
  height: 30px;
  border-top: 1px solid rgba(51, 51, 51, 0.5);
}
.news_con .el-card:hover .news_icon {
  border-top-color: #fefefe;
}
.news_con .news_box .news_time {
  font-size: 16px;
}
.news_con .news_box .news_detail {
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  background: none;
  transition: all 0.3s;
}
/* ::v-deep .el-carousel__container {
  position: relative;
  height: 600px;
} */
.el-carousel {
  width: 100%;
  min-width: 1200px;
}
.el-backtop {
  bottom: 200px !important;
  right: 100px !important;
}
.featured_pages {
  display: block;
  width: 75%;
  min-width: 1200px;
  margin: 20px auto  40px;
  position: relative;
}
.featured_pages li {
  -webkit-flex: 1;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  -moz-flex: 1;
  flex: 1;
  overflow: hidden;
  margin: 0 20px;
}
.featured_pages .featured_icon {
  width: auto;
  height: 100px;
}
.featured_pages .featured_p {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
::v-deep .featured_pages .el-card__body {
  padding: 0;
}
.featured_pages .featured_pic {
  overflow: hidden;
  font-size: 0;
  position: relative;
}
.featured_pages .featured_pic .bg {
  width: 100%;
  transition: all 0.3s;
}
.featured_pages .featured_pic .img {
  /* position: absolute;
  top: 0;
  left: 0; */
  transition: all 0.3s;
  max-width: 100%;
}
.featured_pages .el-card:hover .featured_pic .img {
  transform: scale(1.1);
}
.featured_pages .featured_box {
  position: relative;
  padding: 10px;
  background-color: #ffffff;
}
.featured_pages .el-card:hover .featured_box {
  background-color: rgba(60, 66, 124, 0.7);
  color: #fff;
}
.featured_pages .featured_box .featured_title {
  color: #333;
  /* margin: 0 0 18px 0; */
  height: 30px;
  line-height: 30px;
  word-break: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 16px;
  text-align: left;
  font-weight: bold;
}

.featured_pages .featured_box .featured_introduce {
  color: #7f7f7f;
  /* margin: 0 0 18px 0; */
  height: 30px;
  line-height: 30px;
  word-break: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 14px;
  text-align: left;
}
.featured_pages .el-card:hover .featured_title {
  color: #fff;
}
.featured_pages .el-card:hover .featured_introduce {
  color: #fff;
}
.featured_item{
  margin-right: 30px;
}
.featured_item:last-child{
  margin-right: 0;
}
.un_con {
  display: block;
  width: 75%;
  min-width: 1200px;
  margin: 40px auto;
  position: relative;
  text-align: left;
}
.un_con .el-col {
  position: relative;
}
.un_con .un_title {
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  height: 80px;
  display: inline-block;
  line-height: 80px;
  border-bottom: #999 solid 2px;
}
.un_con .un_box {
  width: 100%;
  margin-top: -1px;
  padding-top: 40px;
  border-top: #eee solid 1px;
}
.un_con .un_box .us_content{
  margin-bottom: 20px;
  white-space: pre-wrap;
  line-height: 25px;
}
.un_con .un_box .us_value{
  padding-top: 10px;
}
.un_con .un_box .us_value i{
  font-weight: bold;
  margin-right: 5px;
}
.un_box .more {
  color: #fff;
  background-color: #3c427c;
  border: 1px solid #3c427c;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s;
  width: 120px;
  margin: 20px 0;
  cursor: pointer;
  text-align: center
}
.un_box .more i {
  margin-right: 5px;
}
.un_box .more:hover {
  color: #3c427c;
  background-color: #fff;
  border: 1px solid #3c427c;
}
.un_box .new_item{
  margin-bottom: 20px;
  cursor: pointer;
  justify-content: flex-start;
}
.un_box .new_item .new_time{
  margin-right: 20px;
  float: left;
  text-align: center;
  font-weight: bold;
}
.un_box .new_time .date{
  width: 50px;
  height: 40px;
  background-color: #eee;
  line-height: 40px;
  font-size: 22px;
}
.un_box .new_time .month{
  width: 50px;
  height: 20px;
  background-color: #999;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
}
.un_box .new_box .new_title{
  font-size: 16px;
  font-weight: bold;
  word-break: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  margin-bottom: 10px;
}
.un_box .new_box .new_content{
  line-height: 25px;
}
.un_box .new_box .new_content span{
  color: #478bb2;
  margin-left: 5px;
}
.client_con {
  display: block;
  width: 75%;
  min-width: 1200px;
  margin: 40px auto;
  position: relative;
  text-align: left;
}
.client_con .client_title{
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  height: 80px;
  display: inline-block;
  line-height: 80px;
  border-bottom: #999 solid 2px;
}
.client_con .client_box{
  width: 100%;
  margin-top: -1px;
  padding-top: 40px;
  border-top: #eee solid 1px;
}
.client_con .client_box .client_icon{
 height: 160px;
 width: auto;
}
</style>
